/* eslint-disable max-len */
import Question from 'images/coin-pages/questions/amp.svg'

import { blogCards, commonSlidesData } from 'pages/loans/[coin]/assets/page-data/commonPageData'

import { ICoinPageData } from '../types'

export const ampPage: ICoinPageData = {
  title: 'coin_66',
  description: 'coin_67',
  // description: 'coin_68',
  h1: (t, _, replacePlaceholders) => (
    <span dangerouslySetInnerHTML={{ __html: replacePlaceholders(t('get_instant_coin_loan'), { coin: 'AMP' }) }} />
  ),
  questionsBlock: {
    image: Question,
    questions: [
      {
        title: 'coin_69',
        answer: 'coin_70',
      },
      {
        title: 'coin_71',
        answer: 'coin_72',
      },
      {
        title: 'coin_73',
        answer: 'coin_74',
      },
      {
        title: 'coin_75',
        answer: 'coin_76',
      },
    ],
  },
  whatIs: {
    ...commonSlidesData('AMP'),
    text: [],
    paragraphs: [
      {
        title: 'coin_77',
        text: ['coin_79'],
      },
      {
        title: 'coin_78',
        text: ['coin_80'],
      },
    ],
    blogCards: [
      {
        link: 'https://coinrabbit.io/blog/amp-coinrabbit/',
        image:
          'https://sp-ao.shortpixel.ai/client/to_webp,q_lossless,ret_img,w_2400/https://coinrabbit.io/blog/wp-content/uploads/2023/06/Gain-profit-2-1.jpg',
        imageAlt: 'Hold AMP & Gain profit',
      },
      blogCards.borrowLikePro,
      blogCards.cryptoCrash,
    ],
  },
}
